import { Fragment } from "react"
import { Route, BrowserRouter as Router, Routes } from "react-router-dom"
import Presentacion from "../Principal/Presentacion"
import Login from "../Home/Login"
import Layout from "../Home/Layout"
import Navegacion from "../Home/Navegacion"
import RegistrarAhorrador from "../Home/RegistrarAhorrador"
import RegistrarContrato from "../Home/RegistrarContrato"
import Contratos from "../Home/Contratos"
import Tyc from "../Home/Tyc"
import SeguimientoAbonos from "../Home/SeguimientoAbonos"
import CalcularIntereses from "../Home/CalcularIntereses"
import Inactividad from "./Inactividad"
import Ahorradores from "../Home/Ahorradores"
import Encuesta from "../Home/Encuesta"
import GraficasEncuesta from "../Home/GraficasEncuesta"
import RegistrarCliente from "../Home/Prestamos/RegistrarCliente"
import Enconstruccion from "../Blog/Enconstruccion"


const Rutas = () => {


    return(
        <Router>
            <Fragment>
                    <Routes>
                        <Route path="/" element={<Presentacion />}/>
                        <Route path="/iniciar-sesion" element={<Login />}/>          
                        <Route path="/home" element={<Layout><Navegacion /></Layout>}/> 
                        <Route path="/registrar-ahorrador" element={<Layout><RegistrarAhorrador /></Layout>}/> 
                        <Route path="/registrar-contrato" element={<Layout><RegistrarContrato /></Layout>}/> 
                        <Route path="/contratos" element={<Layout><Contratos /></Layout>}/> 
                        <Route path="/calculo-interes" element={<Layout><CalcularIntereses /></Layout>}/> 
                        <Route path="/ahorradores" element={<Layout><Ahorradores/></Layout>}/>
                        <Route path="/registrar-cliente" element={<Layout><RegistrarCliente/></Layout>}/> 
                        <Route path="/encuesta" element={<Encuesta/>}/>
                        <Route path="/graficas-encuesta" element={<GraficasEncuesta/>}/>
                        <Route path="/tyc-ahorrador" element={<Tyc />}/> 
                        <Route path="/seguimiento-abonos/:ahorrador" element={<SeguimientoAbonos />}/> 
                        <Route path="/construccion" element={<Enconstruccion />}/> 
                        
                        
                    </Routes>
                    <Inactividad />
                      
            </Fragment>
        </Router>
    )
    


}

export default Rutas